import { useQuery } from '@tanstack/react-query'

import { api } from '../../lib/api'
import type { CalendarEventsResponse } from '../../lib/calendar'

export type CalWindow = { start: string; end: string }

export const CALENDAR_STALE_MS = 60_000

export function personCalendarQuery(personId: string | null, range: CalWindow) {
  return {
    queryKey: ['calendar', 'person', personId, range.start, range.end],
    queryFn: async () =>
      (
        await api.get<CalendarEventsResponse>(`/api/calendar/people/${personId}/events`, {
          params: range,
        })
      ).data,
    staleTime: CALENDAR_STALE_MS,
  }
}

export function usePersonCalendar(personId: string | null, range: CalWindow) {
  return useQuery({ ...personCalendarQuery(personId, range), enabled: personId != null })
}
